import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Input, Typography, Switch } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils"

const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;

const ElectricalComponentForm = props => {
    const { t } = useTranslation();
    const [networkTypes, setNetworkTypes] = useState([]);
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: {
            sm: { span: 8 }
        },
        wrapperCol: {
            sm: { span: 16 }
        }
    };

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/electrical/enums/network-types")
            .then(({ data }) => {
                setNetworkTypes(data);
            })
            .catch(function (error) {
                console.log(error);
            });

        form.setFieldsValue({
            electricalNetworkType: props.record.asset.electricalNetworkType,
            isPrivate: props.record.asset.isPrivate,
            details: props.record.asset.details,
        });
    }, [props.record.asset, form]);

    const onValuesChange = (changedValues) => {
        form.validateFields(Object.keys(changedValues));
    };

    const onFieldsChange = (changedFields, allFields) => {
        const values = form.getFieldsValue();
        var valid = false;

        if (form.getFieldsError().every(e => e === undefined || e.errors.length === 0)) {
            valid = true;
        }

        const newAsset = { ...props.record };
        newAsset.asset.electricalNetworkType = elvis(values.electricalNetworkType);
        newAsset.asset.isPrivate = elvis(values.isPrivate);
        newAsset.asset.details = elvis(values.details);
        newAsset.valid = valid;
        props.parentCallback(newAsset);
    };

    return (
        <Form
            form={form}
            {...formItemLayout}
            className="details_form"
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
        >
            <Title
                className="details_form_header"
                title="Asset details"
                subTitle="Network component"
            />
            <Form.Item label="Type" name="electricalNetworkType">
                <Select>
                    {networkTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('electricalEnums.networkType.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Private" name="isPrivate" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item label="Description" name="details">
                <TextArea />
            </Form.Item>
        </Form>
    );
};

export default ElectricalComponentForm;